/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Axios from '../../axios'
import BaseModal from '../common/BaseModal'

import './AdminExportsContainer.scss'

const GOLF_ED_REPORTS = [
  {
    nameKey: 'common.golf.strokesLost',
    slug: 'strokes_lost',
  },
  {
    nameKey: 'exports.report.events',
    slug: 'events',
  },
  {
    nameKey: 'exports.report.golfersCreated',
    slug: 'golfers_created',
  },
  {
    nameKey: 'exports.report.rounds',
    slug: 'rounds',
  },
  {
    nameKey: 'exports.report.divisionPassers',
    slug: 'division_passers',
  },
]

class AdminExportsContainer extends Component {
  state = {
    email: '',
    responseModal: null,
  }

  render() {
    const { t } = this.props
    const { email, responseModal } = this.state
    return (
      <div id='AdminExportsContainer' className='card p-4'>
        <h2>{t('exports.heading')}</h2>

        <p className='sub-text'>{t('exports.subtext')}</p>
        <label htmlFor='email'>{t('common.field.email')}</label>
        <input
          type='text'
          id='email'
          value={email}
          onChange={this._handleInputChange}
          name='email'
          placeholder={t('exports.emailPlaceholder')}
        />
        <hr />
        {/* =========== this should probably be refactored if more reports are added === */}
        <h4>{t('exports.golfEdHeading')}</h4>
        <p>{t('exports.golfEdDescription')}</p>
        {GOLF_ED_REPORTS.map((report, idx) => (
          <div
            className='d-flex align-items-center justify-content-between mb-2 pl-3'
            key={idx}
          >
            <div className='mr-2'>
              <h5>{t(report.nameKey)}</h5>
            </div>
            <div style={{ flex: '1 1', borderBottom: '2px dotted #ddd' }} />
            <div className='button-box ml-2'>
              <button
                className='btn btn-sm btn-block px-4'
                onClick={() => this._handleExportClick(report.slug)}
              >
                <i className='fa fa-download mr-2' aria-hidden='true' />
                {t('common.action.export')}
              </button>
            </div>
          </div>
        ))}
        {/* ============================================================================ */}
        {!!responseModal && (
          <BaseModal
            close={() => false}
            backable={false}
            hideClose={true}
            width='550px'
          >
            <h4 className='text-center'>
              {t(
                responseModal === 'success'
                  ? 'exports.modalTitle.success'
                  : 'exports.modalTitle.fail'
              )}
            </h4>
            <p className='text-center'>
              {responseModal === 'success'
                ? t('exports.successMessage', { email })
                : t('exports.failMessage')}
            </p>
          </BaseModal>
        )}
      </div>
    )
  }

  _handleExportClick = async (report_slug) => {
    // this will need to be more flexible if more reports are added
    const { email } = this.state
    if (!email) {
      // show an error here -
      return false
    }
    const response = await Axios.get(
      `/api/v1/exports/golf_ed/?report_slug=${report_slug}&email=${email}`
    )
    if (response.status === 200) {
      this.setState({ responseModal: 'success' }, () => {
        setTimeout(this._closeResponseModal, 3500)
      })
    } else {
      this.setState({ responseModal: 'fail' }, () => {
        setTimeout(this._closeResponseModal, 3500)
      })
    }
  }

  _closeResponseModal = () => {
    this.setState({ responseModal: null })
  }

  _handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
}

export default withTranslation()(AdminExportsContainer)
